import { ObterPermissoesRecebimentoNotificacoes } from './obterPermissoesRecebimentoNotificacoes';

(new ObterPermissoesRecebimentoNotificacoes()).executar();

